export const expertBuyOrderEn = {
    qxzfw:"Please select service"
}


// WEBPACK FOOTER //
// ./src/lang/home/expertBuyOrder/indexEn.js